"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./isProductionEnvironment.cjs");function o(){return!n.isProductionEnvironment()}exports.isPreProductionEnvironment=o;
//# sourceMappingURL=isPreProductionEnvironment.cjs.map
